import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import * as styles from "./Header.module.scss";
import { Link } from "gatsby";
import useSearchQuery from "../../../../hooks/useSearchQuery";

const Header = ({ articles }) => {
  const [search, setSearch] = useState("");

  const searchResults = useSearchQuery({ search, data: articles });

  return (
    <header>
      <Link to="/" className={styles.logoWrapper}>
        <StaticImage
          src="../../../../assets/logo.png"
          alt="logo"
          placeholder="tracedSVG"
          imgStyle={{ objectFit: "contain" }}
        />
      </Link>
      <div className={styles.searchWrapper}>
        <div className={styles.search}>
          <label>
            <input placeholder="Søg efter artikel" value={search} onChange={(e) => setSearch(e.target.value)} />
          </label>

          {!!searchResults.length && (
            <ul className={styles.searchResults}>
              {searchResults.map(({ uri, guideTitle }) => (
                <li key={uri}>
                  <Link to={`/da/guide/${uri}`}>{guideTitle}</Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
